export const isInternalUrl = url => { const URI_PREFIXES = ['?', '#', '/', 'https://codilime.com']; return URI_PREFIXES.some(prefix => url.startsWith(prefix)); };
export const matchesPatterns = (patterns, value) => { if (value === undefined || value === null) {
    return false;
} return patterns.some(pattern => value.match(pattern)); };
